module.exports = __webpack_public_path__ + "media/images/走る犬-cf36c56eb6f2ede515f879565a3a15a3.jpg";